import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { TestimonialCaptureAPI } from '../../services/testimonialCaptureAPI';
import { VideoAPI } from '../../services/videoAPI';
import { EnvironmentService } from '../../services/environmentService';


@inject(Router, EnvironmentService, VideoAPI)
export class LinkSubmissionStart {
    constructor(router, envService, videoApi) {
        this.router = router;
        this.videoApi = videoApi;
        this.envService = envService;

        this.capture_key = null;


        this.showVideo = false;

        this.validateName = false;
        this.validateEmail = false;
        this.savingUserInfo = false;
        this.simple_collection_verbiage = 'Leave a Video Review for'; //'Leave a Video Review for';

        this.capture_bottom_img = "images/capture_bottom.png";

        this.app_name = "Magnfi";
        //this.home_url = window.home_url;
        this.home_url = window.location.origin;
        this.logo_img = "images/magnfi-logo-small.png";

        this.is_whitelabel = false;
        this.is_default_verbiage = true;
        if (window.whitelabel) {
            this.capture_bottom_img = "api/whitelabel/getFile?file=capture_bottom";
            this.app_name = window.app_name;
            this.logo_img = "api/whitelabel/getFile?file=site_logo";
            this.is_whitelabel = true;
        }

        this.id = 0;
        this.token = 0;

        if(window.private_label == 1)
        {
            this.private_label =1;
        }

    }


    activate(model, route) {

        this.short = false;

        if (model.method)
            this.method = model.method;

        if(model.short) {
            this.short = model.short;
        } 

        this.capture_key = model.key;

        if (route.settings && route.settings.captureType)
            this.captureType = route.settings.captureType;
        else
            this.captureType = 0;

        if (this.captureType == 2) {
            this.maxRecordTime = 95;
        } else {
            this.maxRecordTime = 55;
        }

        this.api = new TestimonialCaptureAPI(this.captureType);

    }

    attached() {
        if (this.capture_key) {
            this.api.getByCaptureKey(this.capture_key, this.saveLoadSuccess.bind(this), this.saveLoadError.bind(this));
            this.api.getVerbiage(this.capture_key, this.saveLoadSuccess1.bind(this), this.saveLoadError.bind(this));
            this.videoApi.getFeaturedVideosList(this.capture_key, this.getFeaturedVideosSuccess.bind(this), this.saveLoadError.bind(this));
        }

    }

    saveLoadSuccess(org_name, mlink_return_url, chrome_min_ver) {
        this.setData(org_name, mlink_return_url, chrome_min_ver);

        this.checkSupported();

    }
    saveLoadSuccess1(data ) {
       console.log('$$$$$$$$$$$$$$$$$ hey', JSON.stringify(data));     
       console.log('Simple Collection Link : ',data.verbiage.simple_collection_verbiage);
        var simple_collection_verbiage = data.verbiage.simple_collection_verbiage;
        //this.simple_collection_verbiage = 'Leave a Video Review for';
        
        if(simple_collection_verbiage !== null && simple_collection_verbiage !== ''){
            this.is_default_verbiage = false;
            this.simple_collection_verbiage = simple_collection_verbiage;
            console.log('Default verbiage is false ... showing custom verbiage');
        } else {
            this.is_default_verbiage = true;
            console.log('Default verbiage is true ... showing default verbiage')
        }
        /*if(this.is_whitelabel) {
            this.simple_collection_verbiage = (!simple_collection_verbiage) ? this.simple_collection_verbiage : simple_collection_verbiage;
            
            if(simple_collection_verbiage !== null && simple_collection_verbiage !== '' ){
                console.log('emptying the organization name');
                this.org_name = "";
            
            }
        }*/
    }

    getFeaturedVideosSuccess(videos, pubVideosCount) {
        this.featuredVideos = videos;
        this.pubVideosCount = pubVideosCount;
    }

    showVideoClicked(url, videoType, videoId) {

        this.videoApi.updateReviewPageVideoPlayCount(videoType, videoId, () => {

        }, () => {

        } );
        this.videoApi.updateVideoReviewPageFavoriteCount(videoType, videoId, () => {

        }, () => {

        } );
        this.showVideo = true;
        this.videoPlayer.src = url;
        this.videoPlayer.load();
        this.videoPlayer.play();
    }

    showVideoClosed() {
        this.showVideo = false;
        if (this.videoPlayer) {
            this.videoPlayer.pause();
        }
    }

    saveLoadError(msg) {

        if (msg == "invalid key")
            this.router.navigate("/");
 

    }

    setData(org_name, website, mlink_return_url, chrome_min_ver) {

        this.org_name = org_name;
        this.website = website;
        this.chrome_min_ver = chrome_min_ver;

    }

    checkSupported() {
        if (this.envService.isMobile()) {

            var supportedChrome = false;

            if (this.envService.isChrome()) {
                supportedChrome = true;

                if (this.chrome_min_ver) {
                    var version = this.envService.getBrowserVersion();

                    supportedChrome = parseInt(this.chrome_min_ver) <= version;
                }
            }

            if (this.envService.isAndroid() && !supportedChrome) {
                if (this.envService.isChrome())
                    this.router.navigate("#/capture/unsupported");
                else
                    this.router.navigate("#/capture/unsupported?url=link/" + this.capture_key);

            }
        }
    }


    submitUserInfo() {
        if (this.validateUserInfo()) {
            this.savingUserInfo = true;
            this.api.createVideo(
                {
                    customer_first_name: this.customer_first_name,
                    customer_last_name: this.customer_last_name,
                    customer_email: this.customer_email,
                    capture_key: this.capture_key
                },
                this.createVideoCallback.bind(this),
                this.saveLoadError.bind(this));
        }
    }



    createVideoCallback(video_id) {
         this.videoApi.updateVideoCaptureFromSimpleCollectionPage(this.capture_key,() => {},()=>{});
        sessionStorage['magnfi_captureKey'] = this.capture_key;
        this.router.navigate('video/link/' + video_id);
    }

    validateUserInfo() {
        var pass = true;
        this.validateFirstName = false;
        this.validateLastName = false;
        this.validateEmail = false;
        if (this.customer_first_name == null || this.customer_first_name.trim() == '') {
            this.validateFirstName = true;
            pass = false;
        }
        if (this.customer_last_name == null || this.customer_last_name.trim() == '') {
            this.validateLastName = true;
            pass = false;
        }
        if (this.customer_email == null || this.customer_email.trim() == '') {
            this.validateEmail = true;
            pass = false;
        }

        if (!this.is_email(this.customer_email)) {
            this.validateEmail = true;
            pass = false;
        }
        return pass;
    }


    is_email(email) {
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailReg.test(email);
    }
}